export const APP_ROUTES = {
  SUBSCRIBE_FLOW: '/dashboard/subscriptions/new',
} as const;
